var _circle, _circle2, _circle3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgCheckinSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 151,
    viewBox: "0 0 153 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.5,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 76.5,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 75C16 41.8629 42.8629 15 76 15C109.137 15 136 41.8629 136 75C136 108.137 109.137 135 76 135C42.8629 135 16 108.137 16 75Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 115C76.5 115 46.5 82.5 46.5 65C46.5 48.4375 59.9375 35 76.5 35C93.0625 35 106.5 48.4375 106.5 65C106.5 82.5 76.5 115 76.5 115ZM94.1562 57.6562H94L96.6562 55L91.5 49.6875L88.8438 52.3438L71.5 69.8438L64.1562 62.5L61.5 59.8438L56.1875 65L58.8438 67.6562L68.8438 77.6562L71.5 80.3125L74.1562 77.6562L94.1562 57.6562Z",
    fill: "url(#paint0_linear_16059_244019)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16059_244019",
    x1: 76.5,
    y1: 65,
    x2: 76.5,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCheckinSuccess);
export default __webpack_public_path__ + "static/media/img_checkin_success.151ac8551a05e65be5e13e3e6526dbd5.svg";
export { ForwardRef as ReactComponent };